import { HsColor } from '../../math-new/objects/color.class';
import type { HsShader } from '../shaders/classes/shader.class';

/**
 * Handles s material.
 */
export abstract class HsMaterial {
  public color: HsColor = new HsColor(0, 0, 0);

  public abstract getShader(): HsShader;
}
